import OutLineMobileSix from '@assets/icons/outline-mobile-six.svg'
import { Icon } from './Icon'

export const OutLineMobileSixIcon = Icon(OutLineMobileSix)
